import React from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { searchStep } from '../../features/searchStepChange'
import PersonaSearchResult from '../gobal/SearchResult/PersonaSearchResult'
import GlobalLayout from '../layout/GlobalLayout'
import TopMenu from '../layout/TopMenu'
import { UserStatusGoPage } from '../lib/userStatus'

export default function PersonaResult() {
    UserStatusGoPage("/persona-result")
    const dispatch = useDispatch()
    let navigate = useNavigate();
    // click on number to go search step
    function changeStep(step1, step2, step3) {
        dispatch(searchStep({
            step1: step1,
            step2: step2,
            step3: step3
        }))
        navigate("/search");
    }
    return (
        <div>
            <GlobalLayout showTopMenu={false} >
                <TopMenu />

                <div className='pl-10 pr-5 mt-2'>
                    <div className='flex font-firstFont text-sm tracking-wider'>
                        <div className='pr-5 border-r-2'>
                            <NavLink to={'/'} className='flex items-center opacity-60'>
                                <img src="/images/icons/back.svg" alt="back" />
                                <span className='ml-[0.625rem]'>Dashboard</span>
                            </NavLink>
                        </div>
                        <div className='flex ml-7'>
                            <div className='opacity-60 cursor-pointer' onClick={() => changeStep(true, false, false)}>
                                Step 1 Month /
                            </div>
                            <div className='ml-2 opacity-60 cursor-pointer' onClick={() => changeStep(true, true, false)}>
                                Step 2 Type /
                            </div>
                            <div className='ml-2 opacity-60 cursor-pointer' onClick={() => changeStep(true, true, true)}>
                                Step 3 Question
                            </div>
                            <div className='ml-2'>
                                / Personas List
                            </div>
                        </div>
                    </div>
                    <PersonaSearchResult />
                </div>
            </GlobalLayout>
        </div>
    )
}
